import React, { useEffect, useRef, useState } from "react";
import { Button, Text } from "components";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import QualityInwardControlList from "./QualityInwardControl/QualityInwardControlList";
import Tabs from "components/TabNavBar/Tab";

const tabItems = [
  {
    label: "Inward Quality Control",
    value: "Inward Quality",
  },
];

const QualityTopTab = () => {
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState();
  const { id } = useParams();
  const location = useLocation();
  const name = location.state?.name;
  const childRef = React.useRef(null);

  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    setActiveTab(
      sessionStorage.getItem("tab") !== "Inward Quality"
        ? "Inward Quality"
        : sessionStorage.getItem("tab")
    );
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("tab", tab);
  };

  //for paggination ...
  const [count, setCount] = useState();
  const pageSizeInput = [{ size: 20 }, { size: 50 }, { size: 100 }];
  const [recordPerPage, setRecordPerPage] = useState(20);
  const totalPages = count / recordPerPage;
  const roundedTotalPages = Math.ceil(totalPages);

  const options = pageSizeInput.map((resstate) => ({
    label: resstate.size,
    value: resstate.size,
  }));
  const defaultOption = options.find((option) => option.value === 20);

  //for search fuctionallity ...

  const [selectedOption, setSelectedOption] = useState("column");
  const [searchParameter, setsearchParameter] = useState("");
  const [searchParameter2, setsearchParameter2] = useState("");
  const [formDate, setFormDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [page, setPage] = useState(1);

  const [searchCompanySpecificCriteriaId, setsearchCompanySpecificCriteriaId] =
    useState();
  const [
    searchCompanySpecificDateRangeId,
    setsearchCompanySpecificDateRangeId,
  ] = useState();

  //for cloumn
  const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
    useState([]);

  useEffect(() => {
    if (activeTab !== "Adjustment" && activeTab !== "Inward Quality") {
      getsearchCompanySpecificCriteria();
    } else if (activeTab === "Inward Quality") {
      getsearchCompanySpecificCriteriaWaitingforinward();
    } else {
      getsearchCompanySpecificCriteriaforAdjutment();
    }

    getsetsearchcompanyspecificdaterange();
  }, [activeTab]);

  const getsearchCompanySpecificCriteria = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 14 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getsearchCompanySpecificCriteriaWaitingforinward = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 24 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // for Adjustment
  const getsearchCompanySpecificCriteriaforAdjutment = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificcriteria/get",
        { search_pages_id: 11 },
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchCompanySpecificCriteria(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  //for date
  const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
    useState([]);
  const getsetsearchcompanyspecificdaterange = () => {
    axios
      .post(
        "/api/purple-fusion/searchcompanyspecificdaterange/get",
        {},
        {
          ...headers,
        }
      )
      .then((response) => {
        setsearchcompanyspecificdaterange(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    if (searchCompanySpecificCriteria.length > 0) {
      if (activeTab !== "Adjustment") {
        // Check if the first element exists before accessing its id
        if (searchCompanySpecificCriteria[0]) {
          setsearchCompanySpecificCriteriaId(
            searchCompanySpecificCriteria[0].id
          );
        }
      } else {
        // Check if the second element exists before accessing its id
        if (searchCompanySpecificCriteria[1]) {
          setsearchCompanySpecificCriteriaId(
            searchCompanySpecificCriteria[1].id
          );
        }
      }
    }
  }, [searchCompanySpecificCriteria, activeTab]);

  const obj = {
    search_company_specific_criteria_id:
      searchCompanySpecificCriteriaId != undefined
        ? searchCompanySpecificCriteriaId
        : "",
    search_company_specific_date_range_id:
      searchCompanySpecificDateRangeId != undefined
        ? searchCompanySpecificDateRangeId
        : "",
    search_parameter: searchParameter,
  };

  // console.log(obj);
  const addHandler = () => {
    if (activeTab === "Purchase") {
      navigate("/stocktransaction/purchase/add", {
        state: { id: id, item_name: name },
      });
    } else if (activeTab === "Sales") {
      // navigate("/stocktransaction/sale/add", {
      //   state: { id: id, item_name: name },
      // });
    } else if (activeTab === "Manufacture") {
      navigate("/stocktransaction/manufacture/add", {
        state: { id: id, item_name: name },
      });
    } else if (activeTab === "WorkOrder Maintain") {
      // navigate("/stocktransaction/workorder/add", {
      //   state: { id: id, item_name: name },
      // });
    } else if (activeTab === "Adjustment") {
      navigate("/adjustment/add", {
        state: { id: id, item_name: name },
      });
    } else if (activeTab === "deliverychallaninward") {
      navigate("/deliverychallaninward/add", {
        state: { id: id, item_name: name },
      });
    }
  };

  const [erplist, setErplist] = useState([]);

  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);

  const showViewColumn =
    (erplist.some((item) => item.erp_module_id === 20 && item.view) &&
      activeTab === "Inward Quality") ||
    (erplist.some((item) => item.erp_module_id === 20 && item.view) &&
      activeTab === "Purchase") ||
    (erplist.some((item) => item.erp_module_id === 22 && item.view) &&
      activeTab === "Sales") ||
    (erplist.some((item) => item.erp_module_id === 18 && item.view) &&
      activeTab === "Manufacture") ||
    (erplist.some((item) => item.erp_module_id === 33 && item.view) &&
      activeTab === "WorkOrder Maintain") ||
    (erplist.some((item) => item.erp_module_id === 35 && item.view) &&
      activeTab === "Adjustment") ||
    (erplist.some((item) => item.erp_module_id === 35 && item.view) &&
      activeTab === "deliverychallaninward");

  const showAddColumn =
    (erplist.some(
      (item) => item.erp_module_id === 20 && item.add && item.view
    ) &&
      activeTab === "Purchase") ||
    (erplist.some(
      (item) => item.erp_module_id === 22 && item.add && item.view
    ) &&
      activeTab === "Sales") ||
    (erplist.some(
      (item) => item.erp_module_id === 18 && item.add && item.view
    ) &&
      activeTab === "Manufacture") ||
    (erplist.some(
      (item) => item.erp_module_id === 33 && item.add && item.view
    ) &&
      activeTab === "WorkOrder Maintain") ||
    (erplist.some(
      (item) => item.erp_module_id === 35 && item.add && item.view
    ) &&
      activeTab === "Adjustment") ||
    (erplist.some(
      (item) => item.erp_module_id === 35 && item.add && item.view
    ) &&
      activeTab === "deliverychallaninward");

  function downloadExcel() {
    childRef.current.downloadExcel();
  }
  function downloadPdf() {
    childRef.current.downloadPdf();
  }

  //for option change...
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.id);
  };
  console.log(searchParameter);
  console.log(searchParameter2);
  console.log(selectedOption);
  console.log(searchCompanySpecificCriteriaId);

  // Define the criteria you want to hide when activeTab is "Purchase"
  const hiddenCriteria = ["Item Name ", "Item Code "]; // Replace with the actual criteria you want to hide

  const filteredCriteria =
    activeTab === "Purchase"
      ? searchCompanySpecificCriteria.filter(
          (criteria) => !hiddenCriteria.includes(criteria.criteria)
        )
      : searchCompanySpecificCriteria;

  return (
    <>
      {/* {showViewColumn ? ( */}
      <div className="overflow-hidden">
        <div className="flex  flex-row w-full items-center px-2 pt-2">
          <Text
            className="text-base md:text-[22px]  text-gray-800 sm:text-xl tracking-[0.20px] w-[85px] whitespace-nowrap"
            size="txtInterSemiBold24"
          >
            {" "}
            Quality
          </Text>

          {/* Search Fuctionallity.. */}

          <Text
            className="text-sm md:text-[22px] whitespace-nowrap text-gray-600 sm:text-xl tracking-[0.20px] ml-20 mr-1"
            size="txtInterSemiBold24"
          >
            {" "}
            Search By :
          </Text>

          <div className="flex gap-2 items-center justify-center">
            <input
              type="radio"
              id="column"
              name="option"
              checked={selectedOption === "column"}
              onChange={(event) => {
                handleOptionChange(event);
                setsearchCompanySpecificDateRangeId("");
                setsearchParameter("");
                setPage(1);
              }}
              className="scale-100"
            />
            <label className=" text-gray-600  text-sm"> Column</label>

            <input
              type="radio"
              className="scale-100 "
              id="date"
              name="option"
              checked={selectedOption === "date"}
              onChange={(event) => {
                handleOptionChange(event);
                setsearchCompanySpecificCriteriaId("");
                setsearchParameter("");
                setPage(1);
              }}
            />
            <label className=" text-gray-600 text-sm"> Date</label>

            {selectedOption === "column" && (
              <Select
                options={searchCompanySpecificCriteria.map((resstate) => ({
                  label: resstate.criteria,
                  value: resstate.id,
                }))}
                className="bg-white-A700 border border-gray-200_02"
                onChange={(selectedoption) => {
                  setsearchCompanySpecificCriteriaId(selectedoption.value);
                  setPage(1);
                }}
                defaultValue={
                  searchCompanySpecificCriteria.length > 0
                    ? {
                        label: searchCompanySpecificCriteria[0].criteria,
                        value: searchCompanySpecificCriteria[0].id,
                      }
                    : {
                        label:
                          activeTab !== "Adjustment" ? "Code" : "Item Name", // Set default label based on activeTab value
                        value: null, // Set value to null or a default id if necessary
                      }
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "30px", // Adjust the height as needed
                    // minHeight: '10px', // Ensure the minimum height is also set
                    width: "140px", // Adjust the width as needed
                    display: "flex",
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                  }),
                }}
              />
            )}

            {selectedOption === "date" && (
              <Select
                options={searchcompanyspecificdaterange.map((resstate) => ({
                  label: resstate.date_range,
                  value: resstate.search_date_range_id,
                }))}
                className="bg-white-A700 border border-gray-200_02 "
                onChange={(selectedoption) => {
                  setsearchCompanySpecificDateRangeId(selectedoption.value);
                  setPage(1);
                }}
                styles={{
                  control: (base) => ({
                    ...base,
                    height: "30px", // Adjust the height as needed
                    //  minHeight: '10px', // Ensure the minimum height is also set
                    width: "140px", // Adjust the width as needed
                    display: "flex",
                    alignItems: "center", // Center vertically
                    justifyContent: "center", // Center horizontally
                  }),
                }}
              />
            )}

            {selectedOption === "column" && (
              <input
                name="searchParamater"
                type="text"
                placeholder="Search..."
                onChange={(e) => {
                  setsearchParameter(e.target.value);
                  setPage(1);
                }}
                // onChange={formik.handleChange}
                className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-40"
              ></input>
            )}

            {selectedOption === "date" &&
              searchCompanySpecificDateRangeId === 7 && (
                <div className="flex flex-row">
                  <input
                    name="from_date"
                    type="date"
                    onChange={(e) => {
                      setFormDate(e.target.value);
                      setsearchParameter2(e.target.value.concat("@" + toDate));
                      setPage(1);
                    }}
                    className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] w-[40%]  pt-4"
                  />
                  <Text className="text-sm md:text-[22px] text-gray-600  sm:text-xl pt-2  ">
                    To
                  </Text>

                  <input
                    name="to_date"
                    type="date"
                    onChange={(e) => {
                      setToDate(e.target.value);
                      setsearchParameter2(
                        formDate.concat("@" + e.target.value)
                      );
                      setPage(1);
                    }}
                    className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px]   pt-4"
                  />
                </div>
              )}
          </div>

          <div className="flex text-3xl gap-2 flex-row justify-end items-center font-inter px-[10px] w-full leading-none tracking-tight text-gray-900 md:text-4xl lg:text-5xl dark:text-white">
            {showViewColumn && (
              <div
                className="flex flex-col relative z-20"
                onMouseEnter={() => setDownload(!download)}
                onMouseLeave={() => setDownload(!download)}
              >
                <button
                  id="dropdownDefaultButton"
                  data-dropdown-toggle="dropdown"
                  className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  type="button"
                >
                  {"Download"} &nbsp;{" "}
                  <svg
                    class="w-2.5 h-2.5 ms-3"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 10 6"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 4 4 4-4"
                    />
                  </svg>
                </button>
                <div
                  className={`${
                    download ? "absolute top-[32px]" : "hidden"
                  } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                >
                  <ul
                    class="py-0 text-sm text-gray-700 dark:text-gray-200"
                    aria-labelledby="dropdownDefaultButton"
                  >
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadPdf}
                      >
                        PDF
                      </span>
                    </li>
                    <li>
                      <span
                        className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                        onClick={downloadExcel}
                      >
                        Excel
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {/* {showAddColumn && (
              <div className="flex flex-col items-center justify-center">
                {activeTab !== "WorkOrder Maintain" &&
                  activeTab !== "Sales" && (
                    <button
                      type="button"
                      id="dropdownDefaultButton"
                      className="text-white-A700 bg-blue-700  hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 "
                      onClick={() => addHandler()}
                    >
                      + Add
                    </button>
                  )}
              </div>
            )} */}
          </div>
        </div>
        {/* <div className="w-full ">
          <nav className=" p-1 bg-slate-100">
            <div className="container mx-auto">
              <ul className="flex">
                <li
                  className={`mr-6 ml-6 p-2 w-30 text-sm ${
                    activeTab === "Inward Quality"
                      ? "bg-gray-150 text-blue-500 shadow-md"
                      : ""
                  }`}
                >
                  <Button
                    className="text-white "
                    onClick={() => {
                      handleTabClick("Inward Quality");
                    }}
                  >
                    Inward Quality Control
                  </Button>
                </li>
              </ul>
            </div>
          </nav>
        </div> */}
        <Tabs
          tabs={tabItems}
          activeTab={activeTab}
          onTabChange={handleTabClick}
        />
        <div>
          {activeTab === "Inward Quality" && (
            <QualityInwardControlList
              id={id}
              item_name={name}
              ref={childRef}
              obj={obj}
              searchParameter2={searchParameter2}
            />
          )}
        </div>
      </div>
      {/* ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )} */}
    </>
  );
};

export default QualityTopTab;
